import { Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";

export function DisconnectTeacherFromClassButton(props) {
  const intl = useIntl();
  return (
    <Button
      size="sm"
      color="primary"
      disabled={props.removingTeacher}
      outline
      title={
        props.removingTeacher
          ? intl.formatMessage({ id: "TeacherIsBeingRemoved" })
          : intl.formatMessage({ id: "DetachTeacher" })
      }
      onClick={() => props.promptRemoveTeacher(props.teacher)}
    >
      <FormattedMessage id="DetachTeacher" />
    </Button>
  );
}
export default DisconnectTeacherFromClassButton;
